module.exports = __webpack_public_path__ + "img/icn_check_hv_tearai.1e8b844a.png";